import { PayloadAction } from "@reduxjs/toolkit";
import { DesbloqueioCartaoType } from "models/cartao";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import {
  getTokenCartaoByNumero,
  putValidaPushSMS,
  putActivateCC,
  putDesbloquearCC,
  postValidarCartao,
} from "services/http/cliente-service";

import {
  resetLoading,
  setLoading,
  setTitleLoading,
} from "redux/ui/loadings-slice";
import { showMessage } from "utils/messages";
import { LOCAL_STORE_ITOKEN } from "../../../constants";
import { ClienteType } from "models/cliente";

type CartaoState = {
  cartao: DesbloqueioCartaoType;
};

const initialState: CartaoState = {
  cartao: {
    numeroCartao: "",
    tokenCartao: "",
    token: "",
    cpf: "",
    dataNascimento: "",
    criarSenha: "",
    confirmarSenha: "",
    tokenSMS: "",
    tokenSMSUmask: "",
    ativaCC: {},
    sendTokenSMS: false,
    cartaoUnblock: false,
    validarCartao: {} as ClienteType,
  },
};

const handleCartaoCliente = (
  state: CartaoState,
  action: PayloadAction<string>
) => {
  if (state.cartao) {
    state.cartao.numeroCartao = action.payload;
  }
};

export const addCPFUnlockCartao = createAsyncThunk(
  `cliente/setCPFUnlockCartao`,
  async (cpf: string) => {
    return cpf;
  }
);

export const addCelularUnlock = createAsyncThunk(
  `cliente/setCelularUnlock`,
  async (celular: string) => {
    return celular;
  }
);

export const addDataNascUnlockCartao = createAsyncThunk(
  `cliente/setDataNascUnlockCartao`,
  async (dataNascimento: string) => {
    return dataNascimento;
  }
);

export const addCriarSenhaUnlockCartao = createAsyncThunk(
  `cliente/setCriarSenhaUnlockCartao`,
  async (senha: string) => {
    return senha;
  }
);

export const addConfirmarSenhaUnlockCartao = createAsyncThunk(
  `cliente/setConfirmarSenhaUnlockCartao`,
  async (senha: string) => {
    return senha;
  }
);

export const addTokenSMSUnlockCartao = createAsyncThunk(
  `cliente/setTokenSMSUnlockCartao`,
  async (tokenSMS: string) => {
    return tokenSMS;
  }
);

export const addTokenSMSUmaskUnlockCartao = createAsyncThunk(
  `cliente/setTokenSMSUmaskUnlockCartao`,
  async (tokenSMS: string) => {
    return tokenSMS;
  }
);

export const addSendTokenUnlockCartao = createAsyncThunk(
  `cliente/setSendTokenUnlockCartao`,
  async (sendTokenSMS: boolean) => {
    return sendTokenSMS;
  }
);

export const addCartaoUnblock = createAsyncThunk(
  `cliente/setCartaoUnblock`,
  async (cartaoUnblock: boolean) => {
    return cartaoUnblock;
  }
);

export const addCartaoValidator = createAsyncThunk(
  `cliente/setCartaoValidator`,
  async (response: any) => {
    return response;
  }
);

export const addCartaoToken = createAsyncThunk(
  `cliente/setCartaoToken`,
  async (response: any) => {
    return response;
  }
);
export const termoWhatsapp = createAsyncThunk(
  `cliente/setTermosWhatsapp`,
  async (response: any) => {
    return response;
  }
);
export const termosUso = createAsyncThunk(
  `cliente/setTermosUso`,
  async (response: any) => {
    return response;
  }
);

export const fetchTokenCartao = createAsyncThunk(
  `cliente/getTokenCartao`,
  async (numeroCartao: DesbloqueioCartaoType, { dispatch }) => {
    dispatch(setLoading(true));
    // @ts-ignore
    const response = (await getTokenCartaoByNumero(numeroCartao)
      .then(async (res) => {
        dispatch(resetLoading());
        const data = res.data as DesbloqueioCartaoType;
        localStorage.setItem(LOCAL_STORE_ITOKEN, data.token || "");
        await dispatch(fetchValidarCartao(data.tokenCartao || ""));
        return res.data;
      })
      .catch((error) => {
        dispatch(resetLoading());
        const { mensagem } = error.response.data;
        showMessage("warning", "Atenção!", mensagem);
      })) as DesbloqueioCartaoType;
    return response;
  }
);

export const fetchValidarCartao = createAsyncThunk(
  `cliente/postValidarCartaoDados`,
  async (tokenCartao: string, { dispatch }) => {
    dispatch(setLoading(true));
    // @ts-ignore
    const response = (await postValidarCartao(tokenCartao)
      .then((res) => {
        dispatch(resetLoading());
        return res.data;
      })
      .catch((error) => {
        dispatch(resetLoading());
        const { mensagem } = error.response.data;
        showMessage("warning", "Atenção!", mensagem);
      })) as ClienteType;
    return response;
  }
);

export const handleActivateCC = createAsyncThunk(
  `cliente/handleActivateCC`,
  async (cartao: DesbloqueioCartaoType, { dispatch }) => {
    dispatch(setLoading(true));
    dispatch(setTitleLoading("Validando o código informado, um momento..."));
    // @ts-ignore
    const responsePush = await putValidaPushSMS(cartao);

    if (responsePush) {
      dispatch(setTitleLoading("Ativando o teu TeuCard, um momento..."));
      // @ts-ignore
      const response = (await putActivateCC(cartao)
        .then(async (res: { status: any }) => {
          if (res.status >= 200 && res.status < 300) {
            await putDesbloquearCC(cartao)
              .then((res) => {
                if (res.status >= 200 && res.status < 300) {
                  dispatch(resetLoading());
                  dispatch(addCartaoUnblock(true));
                  return res.data;
                }
              })
              .catch((error: { response: { data: { mensagem: any } } }) => {
                dispatch(resetLoading());
                const { mensagem } = error.response.data;
                showMessage("warning", "Atenção!", mensagem);
              });
          }
        })
        .catch((error: { response: { data: { mensagem: any } } }) => {
          dispatch(resetLoading());
          const { mensagem } = error.response.data;
          showMessage("warning", "Atenção!", mensagem);
        })) as DesbloqueioCartaoType;
      dispatch(resetLoading());
      return response;
    }
  }
);

export const cartaoSlices = createSlice({
  name: "cartao",
  initialState: { ...initialState },
  reducers: {
    setCartao: handleCartaoCliente,
    cleanStateUnlock: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTokenCartao.fulfilled, (state, action) => {
      state.cartao.token = action.payload.token;
      state.cartao.tokenCartao = action.payload.tokenCartao;
    });

    builder.addCase(addCPFUnlockCartao.fulfilled, (state, action) => {
      state.cartao.cpf = action.payload;
    });

    builder.addCase(addDataNascUnlockCartao.fulfilled, (state, action) => {
      state.cartao.dataNascimento = action.payload;
    });

    builder.addCase(addCriarSenhaUnlockCartao.fulfilled, (state, action) => {
      state.cartao.criarSenha = action.payload;
    });

    builder.addCase(
      addConfirmarSenhaUnlockCartao.fulfilled,
      (state, action) => {
        state.cartao.confirmarSenha = action.payload;
      }
    );

    builder.addCase(addTokenSMSUnlockCartao.fulfilled, (state, action) => {
      state.cartao.tokenSMS = action.payload;
    });

    builder.addCase(addTokenSMSUmaskUnlockCartao.fulfilled, (state, action) => {
      state.cartao.tokenSMSUmask = action.payload;
    });

    builder.addCase(handleActivateCC.fulfilled, (state, action) => {
      state.cartao.ativaCC = action.payload;
    });

    builder.addCase(addSendTokenUnlockCartao.fulfilled, (state, action) => {
      state.cartao.sendTokenSMS = action.payload;
    });

    builder.addCase(addCartaoUnblock.fulfilled, (state, action) => {
      state.cartao.cartaoUnblock = action.payload;
    });

    builder.addCase(addCartaoToken.fulfilled, (state, action) => {
      state.cartao.token = action.payload.token;
      state.cartao.tokenCartao = action.payload.tokenCartao;
    });

    builder.addCase(fetchValidarCartao.fulfilled, (state, action) => {
      state.cartao.validarCartao = action.payload;
    });

    builder.addCase(addCartaoValidator.fulfilled, (state, action) => {
      state.cartao.validarCartao = action.payload;
    });
    builder.addCase(termosUso.fulfilled, (state, action) => {
      state.cartao.whatsApp = action.payload;
    });
    builder.addCase(termoWhatsapp.fulfilled, (state, action) => {
      state.cartao.termos = action.payload;
    });
  },
});

export const { setCartao, cleanStateUnlock } = cartaoSlices.actions;

export default cartaoSlices.reducer;
